export const labelStyles = 'mt-[16px] block font-extrabold text-[12px]/[14px]';
export const requiredStyles = 'text-[#F02D3A] text-[10px]/[14px] align-top';
// Base input styles without border color - use getInputBorderClass for dynamic borders
export const inputStylesBase =
  'p-[10px] text-[16px]/[20px] border-2 rounded-[4px] transition-colors';
// Legacy static styles (dark border always) - kept for backward compatibility
export const inputStyles =
  'p-[10px] text-[16px]/[20px] border-2 rounded-[4px] border-black transition-colors';
export const sectionStyles = 'mt-[30px] text-[#949599] text-[18px/22px]';

// Helper to get border class based on whether field has a value
export const getInputBorderClass = (value: string | null | undefined): string => {
  return value && value.trim() !== '' ? 'border-black' : 'border-gray-300';
};

// React-select styles with dynamic border based on hasValue
export const getSelectStyles = (hasValue: boolean) => ({
  control: (provided: any, state: any) => ({
    ...provided,
    borderColor: state.isFocused ? '#000' : hasValue ? '#000' : '#d1d5db',
    borderWidth: '2px',
    borderRadius: '4px',
    padding: '2px 4px',
    minHeight: '42px',
    fontSize: '16px',
    lineHeight: '20px',
    boxShadow: 'none',
    backgroundColor: 'white',
    transition: 'border-color 150ms',
    '&:hover': {
      borderColor: state.isFocused ? '#000' : hasValue ? '#000' : '#9ca3af',
    },
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    padding: '6px 8px',
  }),
  input: (provided: any) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: '#9ca3af',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (provided: any) => ({
    ...provided,
    color: '#6b7280',
    '&:hover': {
      color: '#374151',
    },
  }),
  menu: (provided: any) => ({
    ...provided,
    borderColor: '#d1d5db',
    borderWidth: '1px',
    zIndex: 9999,
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#e5e7eb' : state.isFocused ? '#f3f4f6' : 'white',
    color: '#111827',
  }),
});
